<template>
  <div>
    <div class="inp">
      <input placeholder="请输入手机号" v-model="form.mobile" />
    </div>
    <div class="lastInput">
      <input placeholder="请输入验证码" v-model="form.code" />
      <el-button type="primary" @click="getVerify" style="width:140px;" :disabled="disabled=!show">
        <span v-show="count === 0">获取验证码</span>
        <span v-show="count !== 0" class="count">{{count}} s后重新获取</span>
      </el-button>
    </div>
    <!-- <div class="forget">
      <div @click="handlerRegister">忘记密码</div>
      <div>|</div>
      <div @click="handleRegister">注册</div>
    </div> -->
    <button class="login" @click="getLogin">
      登录
    </button>
  </div>
</template>

<script>
import { login, create } from "@/api/common.js";

export default {
  data() {
    return {
      form: {
        mobile: "",
        code: "",
        hash: "",
        key: ""
      },
      show: true,
      count: 0, // 初始化次数
      timer: null
    };
  },
  methods: {
    handlerRegister() {
      this.$router.push({
        path: "/login/find"
      });
    },
    handleRegister() {
      this.$router.push({
        path: "/login/register"
      });
    },
    getVerify() {
      // 验证手机号
      if (this.checkPhone()) {
        this.show = false;
        create("loginCode", {
          mobile: this.form.mobile
        })
          .then(res => {
            this.form.hash = res.data.hash;
            this.form.key = res.data.key;
            const TIME_COUNT = 60; //更改倒计时时间
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          })
          .catch(e => {
            this.show = true;
          });
      }
    },
    checkPhone() {
      let phone = this.form.mobile;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("请填写正确的手机号");
        return false;
      } else {
        return true;
      }
    },
    getLogin() {
      if (!this.form.mobile) return this.$message.error("请输入手机号");
      if (!this.form.code) return this.$message.error("请输入验证码");
      if (!this.form.hash || !this.form.key) return this.$message.error("请重新获取验证码");
      create("login", { ...this.form }).then(res => {
        this.$store
          .dispatch("user/setInfo", {
            ...res.data
          })
          .then(() => {
            if (this.$store.getters.userinfo.role === "others") {
              this.$router.push({
                path: "/maps"
              });
            } else {
              this.$router.push({
                path: `/user/${this.$store.getters.userinfo.role}`
              });
            }
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.inp {
  width: 100%;
  margin-bottom: 50px;
}
input {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 0 15px 20px;
  border-radius: 5px;
  border: none;
  border: 1px solid #ccc;
  outline: none;
}
.lastInput {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  button {
    border: none;
    background-color: #41a5ef;
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }
  input {
    width: 340px;
  }
}
.forget {
  display: flex;
  justify-content: flex-end;
  font-size: 22px;
  margin-bottom: 60px;
  div {
    margin-left: 15px;
    cursor: pointer;
  }
}
.login {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  border: none;
  background-color: #41a5ef;
  color: #fff;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  letter-spacing: 30px;
  text-indent: 30px;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
  .lastInput {
    button {
      padding: 5px 8px;
    }
  }
  .forget {
    font-size: 20px;
    margin-bottom: 30px;
    margin-right: 20px;
  }
  .lastInput input {
    margin-right: 10px;
  }
}
</style>


